(function () {
  var t = document.querySelector('.nav-toggle');
  var n = document.getElementById('site-nav');
  if (t && n) t.addEventListener('click', function () {
    var open = n.classList.toggle('open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.querySelectorAll('[data-variant-select]').forEach(function (s) {
    s.addEventListener('change', function () {
      var p = s.options[s.selectedIndex].getAttribute('data-price');
      var el = document.querySelector('[data-price]');
      if (el && p) el.textContent = p;
    });
  });
})();
